import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-loading-dialog',
  templateUrl: './loading-dialog.component.html',
  styleUrls: ['./loading-dialog.component.scss']
})
export class LoadingDialogComponent implements OnInit, OnDestroy {
  message = 'loading...';
  interval: any;
  lines = new Array(
    'loading awesomeness...',
    'spinning up the hamster...',
    'shovelling coal into the server...',
    'warming up the processors...',
    're-calibrating the internet...',
    'doing something useful...',
    'prepare for awesomeness...',
    'counting backwards from infinity...',
    'testing for perfection...',
    'dividing eternity by zero...',
    'please be patient...',
    // 'waiting for approval from Bill Gates...',
    'making you a cookie...',
    'your time is important to us',
    'making sure your request is completed...',
    'making predictive analysis...',
    'destroying all bugs...',
    'perfomring a load of tasks...',
    'making it pop...',
    'checking shades of grey...',
  );

  constructor(public dialogRef: MatDialogRef<LoadingDialogComponent>) {}

  ngOnInit() {
    this.interval = setInterval(() => {
      this.changeLine();
    }, 5000);
  }

  ngOnDestroy() {
    clearInterval(this.interval);
  }

  changeLine() {
    this.message = this.lines[
      Math.round(Math.random() * (this.lines.length - 1))
    ];
  }
}
